import PropTypes from 'prop-types'
import React from 'react'

import { ICON_SIZE } from '@/checkout-instore-legacy/constants/SizeConstants'
import Icon from '@/checkout-instore-legacy/components/Commons/Icons'
import Link from '@/checkout-instore-legacy/components/Commons/Elements/Link'

function SidebarItem({ id, title, handleClick, icon }) {
  return (
    <Link
      id={id}
      data-testId={id}
      className="flex items-center black-80 pl5 pr4 pv3 mv1 dim f4 w-100 bn tl bg-transparent no-underline"
      defaultColor={false}
      onClick={handleClick}
    >
      {icon ? <Icon type={icon} color="#7D7E80" size={ICON_SIZE} /> : null}
      <div className="pl4">{title}</div>
    </Link>
  )
}

SidebarItem.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  handleClick: PropTypes.func,
}

export default SidebarItem
